export function setRemBase(designWidth = 375, baseFont = 16) {
  const set = () => {
    const w = Math.max(document.documentElement.clientWidth || window.innerWidth, 320)
    const font = (w / designWidth) * baseFont
    document.documentElement.style.fontSize = `${font}px`
  }
  set()
  window.addEventListener('resize', set)
}

export default setRemBase
